import React, { useState, useRef, useEffect } from "react";
//naviagte import
import { useNavigate } from "react-router-dom";
import { FaArrowLeft, FaChevronLeft, FaChevronRight } from "react-icons/fa";
// CSS For Wallet
import "../css/Withdraw.css";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
// Import Font Awesome
// For Solid Icon
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCreditCard,
  faBell,
  faCommentDots,
  faCircleCheck,
  faUser,
  faCog,
  faStar,
  faVideo,
  faUsers,
    faQuestionCircle,
  faBookmark,
  faSignOutAlt


} from "@fortawesome/free-solid-svg-icons";


// Import Iconify for icons
import { Icon } from "@iconify/react";




const BASE_URL = "http://192.168.1.10:8000";

function Withdraw() {


  //withdraw
  const [amount, setAmount] = useState(2500);
  const balance = 18000;

  const increase = () => {
    if (amount + 500 <= balance) setAmount(amount + 500);
  };

  const decrease = () => {
    if (amount - 500 >= 0) setAmount(amount - 500);
  };

  //msg
      const [showMsgDrawer, setShowMsgDrawer] = useState(false);
  // for top tabs functionality
   // modal 
      const [modal, setModal] = useState(false);
      //msg tab acitivate
      // const [activeTab, setActiveTab] = useState("all");
  
      const toggle = () => setModal(!modal);
  const [activeTab, setActiveTab] = useState("forYou");
  //navigate page
  const navigate = useNavigate();
  // for prime public button click 


  // for sidebar buttons
  const [activeSidebar, setActiveSidebar] = useState("prime");


  // for menu toggle functionality
  const [showSidebar, setShowSidebar] = useState(true);

  // profile settings
  const [showProfile, setShowProfile] = useState(false);
  const profileRef = useRef(null);

  // Close popup when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (profileRef.current && !profileRef.current.contains(e.target)) {
        setShowProfile(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);


  //naviagte profile page
  const goToProfile = () => {
    navigate("/profile");
  };

  //localstorage token
  //logout 

  const handleLogout = () => {
    const confirmLogout = window.confirm("Are you sure you want to logout?");//alert for confirmation

    if (confirmLogout) {
      //clear everything
      // localStorage.clear();

      //Redirect to login page
      navigate("/login");
    }
  };


  return (
    <div className="page-wrapper">
      {/* <div className="page-container"> */}

      {/* ================= GLOBAL TOP-RIGHT ICONS ================= */}
     <div className="page-top-container">
                   <nav className="navbar top-header px-3 px-md-5">
   
                       {/* -----------company Logo------------ */}
                       <div
                           className="company-logo"
                           onClick={() => setShowSidebar(prev => !prev)}
                       >
                           <img src="/images/logo1.jpg" alt="logo1" />
                       </div>
   
                       {/*  */}
   
                       <div className="search-box">
                           <i className="prime-search-icon"><Icon icon="ic:sharp-search" /></i>
                           <input
                               type="text"
                               placeholder="Search Politics , Parties and Leadership"
                           />
                       </div>
   
   
                       <div className="global-icons d-flex gap-0 gap-md-2 align-items-center">
   
                           {/* Wallet */}
                           {/* <span className="position-relative border-0">
                               <FontAwesomeIcon icon={faCreditCard} className="icon-box" />
                               <span className="global-creditCard-data position-absolute translate-middle badge rounded-pill bg-danger">
                                   <Icon icon="ic:sharp-currency-rupee" />50
                               </span>
                           </span> */}
                           <span
                               className="position-relative border-0 cursor-pointer"
                               onClick={() => navigate("/wallet")}
                           >
                               <FontAwesomeIcon
                                   icon={faCreditCard}
                                   className="icon-box"
                               />
   
                               <span className="global-creditCard-data position-absolute translate-middle badge rounded-pill bg-danger">
                                   <Icon icon="ic:sharp-currency-rupee" /> 50
                               </span>
                           </span>
   
                           {/*----------------------- Notification---------------------- */}
   
                           <span
                               className="position-relative border-0 bell-icon"
                               style={{ cursor: "pointer" }}
                               onClick={toggle}
                           >
                               <FontAwesomeIcon icon={faBell} className="icon-box" />
                               {/* <span className="global-bell-data badge bg-danger">5</span> */}
                           </span>
   
                           {/* Reactstrap Modal */}
                           <Modal isOpen={modal} toggle={toggle} centered>
                               <ModalHeader toggle={toggle}>
                                   Notifications
                               </ModalHeader>
   
                               <ModalBody>
                                   <p>Your post received new likes.</p>
                                   <small className="text-muted">2 days ago</small>
   
                                   <hr />
   
                                   <p>
                                       Learn how Meta will use your info in new ways to personalize your
                                       experience.
                                   </p>
                                   <small className="text-muted">9 weeks ago</small>
                               </ModalBody>
   
                               <ModalFooter>
                                   <Button color="secondary" onClick={toggle}>
                                       Close
                                   </Button>
                               </ModalFooter>
                           </Modal>
   
                           {/* ----------------------------Profile ---------------------------------- */}
   
                           <span
                               className="position-relative border-0 msg-icon"
                               onClick={() => setShowMsgDrawer(true)}
                           >
                               <FontAwesomeIcon icon={faCommentDots} className="icon-box" />
                           </span>
   
   
                           {/* PROFILE ICON */}
                           <div className="position-relative" ref={profileRef}>
                               <FontAwesomeIcon
                                   icon={faUser}
                                   className="icon-box profile-icon"
                                   onClick={() => setShowProfile(!showProfile)}
                               />
   
                               {/* PROFILE POPUP */}
                               {showProfile && (
                                   <div className="profile-popup">
   
                                       {/* Profile Card */}
                                       <div className="profile-card">
                                           <div className="profile-header">
                                               <div className="avatar">
                                                   <FontAwesomeIcon icon={faUser} />
                                               </div>
                                               <span className="username">Helena king</span>
                                           </div>
   
                                           <div className="divider"></div>
   
                                           <button
     className="see-profile-btn"
     onClick={() => navigate("/profile")}
   >
     <FontAwesomeIcon icon={faUsers} /> My Profile
   </button>
   
                                       </div>
   
                                       {/* Menu Items */}
                                       <div className="profile-popup-item">
                                           <FontAwesomeIcon icon={faCog} />
                                           <span>Settings & privacy</span>
                                           {/* <span className="arrow">›</span> */}
                                       </div>
   
                                       <div className="profile-popup-item">
                                           <FontAwesomeIcon icon={faQuestionCircle} />
                                           <span>Help & support</span>
                                           {/* <span className="arrow">›</span> */}
                                       </div>
   
                                       <div
                                           className="profile-popup-item logout"
                                           onClick={handleLogout}
                                       >
                                           <FontAwesomeIcon icon={faSignOutAlt} />
                                           <span>Logout</span>
                                       </div>
   
                                       {/* Footer */}
                                       <div className="popup-footer">
                                           Privacy · Terms · Advertising · Ad Choices · Cookies · More
                                       </div>
                                   </div>
                               )}
                           </div>
   
   
                       </div>
                   </nav>
               </div>
   
               {/* ----------------------------------Msg Drawer-------------------------------------- */}
               {showMsgDrawer && (
                   <>
                       <div
                           className="msg-overlay"
                           onClick={() => setShowMsgDrawer(false)}
                       ></div>
   
                       <div className="msg-drawer">
                           <div className="msg-header">
                               <h3>Chats</h3>
                               <span onClick={() => setShowMsgDrawer(false)}>✕</span>
                           </div>
   
                           <div className="msg-search">
                               <input placeholder="Search Messenger" />
                           </div>
   
                           {/* <div className="msg-tabs">
                               <span className="active">All</span>
                               <span>Unread</span>
                               <span>Groups</span>
                               <span>Communities</span>
                           </div> */}
                           <div className="msg-tabs">
                               <span
                                   className={activeTab === "all" ? "active" : ""}
                                   onClick={() => setActiveTab("all")}
                               >
                                   All
                               </span>
   
                               <span
                                   className={activeTab === "unread" ? "active" : ""}
                                   onClick={() => setActiveTab("unread")}
                               >
                                   Unread
                               </span>
   
                               <span
                                   className={activeTab === "groups" ? "active" : ""}
                                   onClick={() => setActiveTab("groups")}
                               >
                                   Groups
                               </span>
   
                               <span
                                   className={activeTab === "communities" ? "active" : ""}
                                   onClick={() => setActiveTab("communities")}
                               >
                                   Communities
                               </span>
                           </div>
   
                           <div className="msg-empty">
                               <h4>No chats</h4>
                               <p>When you have chats, you’ll see them here..</p>
                           </div>
   
                           <div
                               className="msg-footer"
                               onClick={() => {
                                   setShowMsgDrawer(false);
                                   navigate("/message");
                               }}
                           >
                               See all in Messenger
                           </div>
                       </div>
                   </>
               )}

      {/* ================= PRIME LAYOUT CONTAINER ================= */}
      <div className="prime-layout">
        <div className="row prime-row">

          {/* ================= LEFT SIDEBAR ================= */}
          <div
            className={`sidebar-container col-lg-3 col-md-3 d-md-block ${showSidebar ? "sidebar-hide" : "sidebar-show"} `}
          >
            <aside className="sidebar">
              <ul className="left-menu">

                <li
                  className={activeSidebar === "prime" ? "menu-item active" : "menu-item"}
                  onClick={() => setActiveSidebar("prime")}
                >
                  <FontAwesomeIcon icon={faStar} /> Prime
                </li>


                <li
                  className={activeSidebar === "public" ? "menu-item active" : "menu-item"}
                  onClick={() => setActiveSidebar("public")}
                >
                  <FontAwesomeIcon icon={faUsers} /> Public
                </li>



                <li
                  className={activeSidebar === "revolution" ? "menu-item active" : "menu-item"}
                  onClick={() => setActiveSidebar("revolution")}
                >
                  <FontAwesomeIcon icon={faVideo} /> Revolution
                </li>
                <li
                  className={activeSidebar === "wallet" ? "menu-item active" : "menu-item"}
                  onClick={() => setActiveSidebar("wallet")}
                >
                  <FontAwesomeIcon icon={faCreditCard} /> Wallet
                </li>
                {/* <li
                                            className={activeSidebar === "bookmarks" ? "menu-item active" : "menu-item"}
                                            onClick={() => setActiveSidebar("bookmarks")}
                                        >
                                            <FontAwesomeIcon icon={faBookmark} /> Bookmarks
                                        </li> */}

                <li
                  className={activeSidebar === "profile" ? "menu-item active" : "menu-item"}
                  onClick={() => setActiveSidebar("profile")}
                >
                  <FontAwesomeIcon icon={faUser} /> Profile
                </li>

                <li
                  className={activeSidebar === "settings" ? "menu-item active" : "menu-item"}
                  onClick={() => setActiveSidebar("settings")}
                >
                  <FontAwesomeIcon icon={faCog} /> Settings
                </li>

              </ul>
             
            </aside>
          </div>
          {/* ================= CENTER AREA ================= */}
          <div className="col-md-9 col-12 withdraw-div">
            <div className="withdraw-wrapper">
              {/* Header */}
              <div className="withdraw-header">
                 <div className="back" onClick={() => navigate(-1)}>
      <FaArrowLeft />
      <span>Withdraw</span>
    </div>
              </div>

              {/* User */}
              <div className="withdraw-user">
                <img
                  src="https://i.pravatar.cc/150?img=32"
                  alt="user"
                  className="user-img"
                />
                <h3>Helena King <span className="verified"> <FontAwesomeIcon icon={faCircleCheck} className="verified-icon" /></span></h3>
              </div>

              {/* Balance Card */}
              <div className="balance-card">
                <p className="balance-text">
                  Your Balance : <span>₹ {balance.toLocaleString()}</span>
                </p>

                <p className="withdraw-label">Withdraw</p>

                <div className="withdraw-box">
                  <FaChevronLeft onClick={decrease} />
                  <span>{amount.toLocaleString()}</span>
                  <FaChevronRight onClick={increase} />
                  <div className="rupee">₹</div>
                </div>
              </div>

              {/* Monetization */}
              <h4 className="monet-title">Monetization Overview</h4>

              <div className="performance-card">
                <h5>Your Performance</h5>

                <div className="progress-row">
                  <span>Followers * 12.4k</span>
                  <div className="progress-bar">
                    <div className="progress-fill w-30"></div>
                  </div>
                </div>

                <div className="progress-row">
                  <span>Likes * 85.9k</span>
                  <div className="progress-bar">
                    <div className="progress-fill w-80"></div>
                  </div>
                </div>

                <div className="progress-row">
                  <span>Shares * 3.2k</span>
                  <div className="progress-bar">
                    <div className="progress-fill w-10"></div>
                  </div>
                </div>
              </div>
            </div>



          </div>
        </div>

        {/* ================= RIGHT SIDEBAR ================= */}

      </div>
    </div>





  );
}
export default Withdraw;